import { useQuery } from '@apollo/client'
import {
  GET_SCREENING_RULES,
  ScreeningRulesData
} from '../../data/gql/questionnaire/queries/screeningRules'
import { LoggerErrorType } from '../../data/logger'
import { captureApolloError } from '../../utils/HelperFunctions'
import { useOptionalWaveId } from '../useOptionalWaveId'
import { useProjectId } from '../useProjectId'
import { useSurveyId } from '../useSurveyId'

export const useGetScreeningRules = () => {
  const projectId = useProjectId()
  const surveyId = useSurveyId()
  const waveId = useOptionalWaveId()

  const { data, loading } = useQuery<ScreeningRulesData>(GET_SCREENING_RULES, {
    context: { clientName: 'questionnaire' },
    variables: { projectId, surveyId, waveId },
    onError: (error) => {
      captureApolloError(LoggerErrorType.ApolloQuery, 'screeningRules', error)
    }
  })

  return {
    screeningRules: data?.draftAudience?.screeningRules,
    loading
  }
}
